import { ReactNode, ElementType } from 'react';
import { AgenciesQuery, ResidencesQuery } from '../../graphql/graphql';

export enum BusinessItemsType {
  agencies = 'agencies',
  residences = 'residences'
}

type ResidenceItem = ResidencesQuery['residences'][number] & {
  showPerUnit: boolean;
  cypress: string;
  stat: string;
};

export type Item = ResidenceItem | AgenciesQuery['agencies'][number];

export interface BusinessItemsListPageProps {
  setErrorUI: (arg: boolean) => void;
  title: string;
  hasError: boolean;
  CardComponent?: ElementType;
  ListContainer: ElementType;
  items: Item[];
  type?: BusinessItemsType;
  children?: ReactNode;
  loading?: boolean;
  isMapView?: boolean;
  mapView?: React.ReactNode;
}
